import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
const CloseBlueIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/FecharBlue.svg';

export type TagInfoProps = {
  icon: ReactNode;
  info: string;
  closeButton?: boolean;
  onClickClose?: () => void;
  type?: 'WARNING' | 'INFO';
};

const containerModifier = {
  WARNING: () => css`
    background: #fef9f1;
    border-left: 6px solid #f2b050;
    & .info {
      color: #d39131;
    }
  `,
  INFO: () => css`
    background: #ebf7fd;
    border-left: 6px solid #009ddc;
    & .info {
      color: #0376a3;
    }
  `
};

const Container = styled.div<{ type: 'WARNING' | 'INFO' }>`
  display: flex;
  flex-direction: row;
  padding: 16px;
  align-items: center;

  & .info {
    font-size: 14px;
    font-weight: 500;
    margin-right: 16px;
  }

  ${props => containerModifier[props.type]()}

  & .close-button {
    margin-left: auto;
    width: 24px;
    height: 24px;
  }
`;

const IconWrapper = styled.div`
  padding-right: 13px;
`;

const TagInfo: React.FC<TagInfoProps> = ({ icon, info, closeButton, onClickClose, type = 'INFO' }) => {
  return (
    <Container type={type}>
      <IconWrapper>{icon}</IconWrapper>
      <p className="info">{info}</p>
      {closeButton && <img onClick={onClickClose} className="close-button" src={CloseBlueIcon} alt="taginfo-fechar" />}
    </Container>
  );
};

export default TagInfo;
